export default "/images/phone-footer.png?4967d18c22324e5865cef930455e45f9";